<div class="login-container">
  <div class="login-box">
    <div class="login-header">
      <h1 class="portal-title">Logistikportal</h1>
      <h2>Anmeldung</h2>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="tryLogin()" class="login-form">
      <div class="form-group">
        <label for="email">E-Mail</label>
        <input 
          type="email" 
          id="email" 
          formControlName="email" 
          class="form-control"
          [ngClass]="{'is-invalid': submitted && f['email'].errors}"
        >
        <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
          <div *ngIf="f['email'].errors['required']">E-Mail ist erforderlich</div>
          <div *ngIf="f['email'].errors['email']">Bitte geben Sie eine gültige E-Mail-Adresse ein</div>
        </div>
      </div>

      <div class="form-group">
        <label for="password">Passwort</label>
        <input 
          type="password" 
          id="password" 
          formControlName="password" 
          class="form-control"
          [ngClass]="{'is-invalid': submitted && f['password'].errors}"
        >
        <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
          <div *ngIf="f['password'].errors['required']">Passwort ist erforderlich</div>
        </div>
      </div>

      <div class="form-group">
        <button [disabled]="loading" class="btn btn-primary">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          Anmelden
        </button>
        <a routerLink="/forgot-password" class="btn btn-link">Passwort vergessen?</a>
      </div>
    </form>
  </div>
